import type { Icon } from "@phosphor-icons/react";
import type { Except } from "type-fest";

import { useMenu } from "./MenuContext";

export const MenuAction: React.FC<
  Except<React.ComponentProps<"button">, "onClick"> & {
    icon?: Icon;
    onClick: () => void;
  }
> = ({ icon: Icon, children, onClick, ...props }) => {
  const { closeMenu } = useMenu();
  return (
    <button
      onClick={() => {
        closeMenu();
        onClick();
      }}
      {...props}
    >
      {Icon && <Icon weight="bold" className="size-4" />}
      {children}
    </button>
  );
};
